import { render, staticRenderFns } from "./GraphLibraryWidget.vue?vue&type=template&id=2b58bb8c&scoped=true"
import script from "./GraphLibraryWidget.vue?vue&type=script&lang=js"
export * from "./GraphLibraryWidget.vue?vue&type=script&lang=js"
import style0 from "./GraphLibraryWidget.vue?vue&type=style&index=0&id=2b58bb8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58bb8c",
  null
  
)

export default component.exports